module.exports = __webpack_public_path__ + "68d150ef1aeebf24461dba71091983ca.pdf";